import { FOA_EEA_THRESHOLD_NOK } from "./getThresholdInfo";

export type EspdRequirement =
  | { required: "unknown" }
  | { required: true; value: string }
  | { required: false; value: string };

export function computeEspdRequirement(
  estimatedValueNok: number | null | undefined,
): EspdRequirement {
  if (estimatedValueNok == null) {
    return { required: "unknown" };
  }

  const value = formatNok(estimatedValueNok);

  if (estimatedValueNok >= FOA_EEA_THRESHOLD_NOK) {
    return { required: true, value };
  }

  return { required: false, value };
}

function formatNok(value: number): string {
  return new Intl.NumberFormat("nb-NO", {
    style: "currency",
    currency: "NOK",
    maximumFractionDigits: 0,
  }).format(value);
}
